// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const LOAD_FEED_NEWEST = "Prejdi na najnov\u0161ie pr\u00edspevky";
